var map = {
	"./icon_facebook": 1000,
	"./icon_facebook.js": 1000,
	"./icon_instagram": 1001,
	"./icon_instagram.js": 1001,
	"./icon_linkedin": 1002,
	"./icon_linkedin.js": 1002,
	"./icon_x": 1003,
	"./icon_x.js": 1003,
	"./icon_youtube": 1004,
	"./icon_youtube.js": 1004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1009;